import { __decorate, __metadata } from "tslib";
import { Task } from '@lit/task';
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { icons } from './icons';
let IconElement = class IconElement extends LitElement {
    constructor() {
        super(...arguments);
        this.iconLoadTask = new Task(this, ([iconName]) => this.loadImage(iconName), () => [this.icon]);
    }
    static { this.tagName = 'inch-icon'; }
    static { this.styles = css `
    :host {
      display: flex;
      width: fit-content;
      height: fit-content;
    }
  `; }
    render() {
        const styles = {
            width: this.width ?? this.iconRecord?.width,
            height: this.height ?? this.iconRecord?.height,
        };
        return this.iconLoadTask.render({
            pending: () => html `<div style="${styleMap(styles)}"></div>`,
            complete: (svg) => {
                if (typeof svg === 'function') {
                    return svg({ ...styles, props: this.props });
                }
                return svg;
            },
        });
    }
    async loadImage(iconName) {
        if (!iconName) {
            throw new Error('icon is required field for inch-icon element');
        }
        this.iconRecord = icons[iconName];
        if (!this.iconRecord) {
            throw new Error(`icon name ${iconName} not exist`);
        }
        return await this.iconRecord.loader();
    }
};
__decorate([
    property({ type: String, attribute: 'icon' }),
    __metadata("design:type", String)
], IconElement.prototype, "icon", void 0);
__decorate([
    property({ type: String, attribute: true }),
    __metadata("design:type", String)
], IconElement.prototype, "width", void 0);
__decorate([
    property({ type: String, attribute: true }),
    __metadata("design:type", String)
], IconElement.prototype, "height", void 0);
__decorate([
    property({ type: Object }),
    __metadata("design:type", Object)
], IconElement.prototype, "props", void 0);
IconElement = __decorate([
    customElement(IconElement.tagName)
], IconElement);
export { IconElement };
//# sourceMappingURL=icon.element.js.map